import { render, staticRenderFns } from "./ConfirmEditProfile.vue?vue&type=template&id=08d8cb27&scoped=true&"
import script from "./ConfirmEditProfile.vue?vue&type=script&lang=js&"
export * from "./ConfirmEditProfile.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEditProfile.vue?vue&type=style&index=0&id=08d8cb27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8cb27",
  null
  
)

export default component.exports